@if(loader.loading$ | async) {
  <app-loader />
}

@if(isDevEnvironment) {
  <div class="position-fixed bottom-0 end-0 m-4 p-2 bg-white rounded-pill shadow border border-warning" style="z-index: 9999;">
    <div class="form-check form-switch mb-0 d-flex align-items-center gap-2">
      <input 
        class="form-check-input mt-0" 
        type="checkbox" 
        role="switch" 
        id="globalDomainToggle" 
        [checked]="isPervolareMode"
        (change)="toggleDominioPrueba($event)"
        style="cursor: pointer;"
      >
      <label 
        class="form-check-label fw-bold f-12" 
        [ngClass]="isPervolareMode ? 'text-warning' : 'text-primary'" 
        for="globalDomainToggle" 
        style="cursor: pointer; width: 65px; user-select: none;"
      >
        {{ isPervolareMode ? 'Pervolare' : 'TAS' }}
      </label>
    </div>
  </div>
}

<router-outlet></router-outlet>